export const version = "1.7.17";
export const channel = "release";
export const gitcommit = "unknown";
